import notNull from "./utils/notNull";
import { podeTrocarPrefeitura } from "./components/seletor-prefeitura/regras";

let _userInfo =
  localStorage.getItem("User_Info") !== null
    ? JSON.parse(localStorage.getItem("User_Info"))
    : {
        login: "",
        nome: "",
        perfil: "",
        prefeituraId: undefined,
        usuarioId: undefined,
        prefeituraSelecionadaId: undefined,
        municipioId: undefined,
      };

export default class UserInfo {
  static estaAutenticado() {
    this.controlarValidadeToken();

    const usuarioId = _userInfo === undefined ? undefined : _userInfo.usuarioId;
    return usuarioId !== undefined;
  }

  static gerenciaPrefeitura() {
    this.controlarValidadeToken();

    if (!notNull(_userInfo)) {
      return false;
    }

    return !notNull(_userInfo.prefeituraId);
  }

  // Grava o usuário do login ou do reload_tenant. Para o perfil trimap, a prefeitura
  // corrente é a do token (PrefeituraSelecionada); 0 significa "ainda sem prefeitura".
  static setUsuario(e) {
    const usuario = { ...e };
    if (notNull(e.prefeituraSelecionada)) {
      usuario.prefeituraSelecionadaId = e.prefeituraSelecionada;
    }
    localStorage.setItem("User_Info", JSON.stringify(usuario));
    _userInfo = usuario;
  }

  static possuiRecurso(recurso) {
    return _userInfo.permissoes.includes(recurso);
  }

  static controlarValidadeToken() {
    const dataCorrente = new Date();

    if (typeof _userInfo.validadeToken == "string") {
      _userInfo.validadeToken = new Date(_userInfo.validadeToken);
    }

    if (_userInfo.validadeToken < dataCorrente) {
      localStorage.removeItem("User_Info");
      localStorage.removeItem("Token");
      window.location.reload();
    }
  }
  static getPrefeitura() {
    this.controlarValidadeToken();

    if (!UserInfo.eSuporte()) {
      return _userInfo.prefeituraId;
    }

    if (!notNull(_userInfo.prefeituraSelecionadaId)) {
      return 0;
    }

    return _userInfo.prefeituraSelecionadaId;
  }

  static getMunicipioId() {
    this.controlarValidadeToken();

    return _userInfo.municipioId;
  }

  static possuiPerfil(perfis) {
    this.controlarValidadeToken();

    return perfis.indexOf(_userInfo.perfil) > -1;
  }

  static possuiSubPerfil(subPerfil) {
    this.controlarValidadeToken();
    return _userInfo.subPerfil.indexOf(subPerfil) > -1;
  }

  static nomeUsuarioLogado() {
    this.controlarValidadeToken();
    return _userInfo.nome;
  }

  static getUsuarioId() {
    this.controlarValidadeToken();

    if (_userInfo.usuarioId === undefined) {
      return 0;
    }

    return _userInfo.usuarioId;
  }

  static eSuporte() {
    this.controlarValidadeToken();

    return podeTrocarPrefeitura(_userInfo);
  }
}

let _fnForceAppUpdateView;

export function setForcarUpdate(fnForceAppUpdateView) {
  _fnForceAppUpdateView = fnForceAppUpdateView;
}

export function forcarUpdate() {
  if (_fnForceAppUpdateView) {
    _fnForceAppUpdateView();
  }
}
